import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    SetProductIdsParameter,
} from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/LoadProductsToCompare";

addToChainAfter(chain, SetProductIdsParameter, props => {
    props.apiParameter.expand?.push("properties");
    props.apiParameter.expand?.push("warehouses");
});
